function initializeGlobalContext(modalContext, controller) {
    /**
   * NON USARE
   * questo è un trucco per gestire le confirm che vengono lancitare "fuori" dal lifecycle di React
   * e non possono ereditare il contensto.
   */
    modalContext.setContext = (ctx) => { controller.setContext(ctx); };
    modalContext.getContext = () => controller.getContext();
    modalContext.setOpenOrGlobal = (open, setOpen, options) => {
        if (setOpen) {
            setOpen(open, options);
        }
        else if (controller.getContext() && controller.getContext().setOpen) {
            controller.getContext().setOpen(open, options);
        }
    };
    modalContext.subscribeOrGlobal = (subscribe, callback) => {
        if (subscribe) {
            subscribe(callback);
        }
        else if (controller.getContext() && controller.getContext().subscribe) {
            controller.getContext().subscribe(callback);
        }
    };
    modalContext.unsubscribeOrGlobal = (unsubscribe, callback) => {
        if (unsubscribe) {
            unsubscribe(callback);
        }
        else if (controller.getContext() && controller.getContext().unsubscribe) {
            controller.getContext().unsubscribe(callback);
        }
    };
}

export { initializeGlobalContext as default };
